"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dropdown = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const useOnClickOutside_1 = require("../hooks/useOnClickOutside");
/** A small positioned dropdown with an internally controlled open state. */
function Dropdown({ children, menuStyle, trigger }) {
    var _a, _b, _c;
    const [open, setOpen] = (0, react_1.useState)(false);
    const dropdownRef = (0, react_1.useRef)(null);
    const menuRef = (0, react_1.useRef)(null);
    const [menuLayout, setMenuLayout] = (0, react_1.useState)(null);
    (0, useOnClickOutside_1.useOnClickOutside)(dropdownRef, () => setOpen(false), open);
    (0, react_1.useLayoutEffect)(() => {
        if (!open) {
            setMenuLayout(null);
            return;
        }
        const updateMenuLayout = () => {
            const dropdown = dropdownRef.current;
            const menu = menuRef.current;
            if (!dropdown || !menu)
                return;
            const trigger = dropdown.getBoundingClientRect();
            const viewportPadding = 8;
            const spaceAbove = Math.max(0, trigger.bottom - viewportPadding);
            const spaceBelow = Math.max(0, window.innerHeight - trigger.top - viewportPadding);
            const preferredMaxHeight = Math.min(window.innerHeight * 0.7, menu.scrollHeight);
            const opensAbove = spaceBelow < preferredMaxHeight && spaceAbove > spaceBelow;
            const availableHeight = opensAbove ? spaceAbove : spaceBelow;
            setMenuLayout({
                bottom: opensAbove ? window.innerHeight - trigger.bottom + 4 : undefined,
                left: trigger.right + 4,
                maxHeight: Math.max(1, Math.min(preferredMaxHeight, availableHeight)),
                top: opensAbove ? undefined : trigger.top,
            });
        };
        updateMenuLayout();
        window.addEventListener("resize", updateMenuLayout);
        window.addEventListener("scroll", updateMenuLayout, true);
        return () => {
            window.removeEventListener("resize", updateMenuLayout);
            window.removeEventListener("scroll", updateMenuLayout, true);
        };
    }, [open]);
    return ((0, jsx_runtime_1.jsxs)("div", { ref: dropdownRef, style: { height: "100%", position: "relative", width: "100%" }, children: [(0, jsx_runtime_1.jsx)("button", { type: "button", "aria-expanded": open, onClick: () => setOpen((isOpen) => !isOpen), style: { background: "none", border: 0, cursor: "pointer", height: "100%", padding: 0, width: "100%" }, children: trigger }), open && ((0, jsx_runtime_1.jsx)("div", { ref: menuRef, style: {
                    backgroundColor: "#282828",
                    border: "1px solid #8f8f8f",
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                    left: (_a = menuLayout === null || menuLayout === void 0 ? void 0 : menuLayout.left) !== null && _a !== void 0 ? _a : "calc(100% + 4px)",
                    maxHeight: (_b = menuLayout === null || menuLayout === void 0 ? void 0 : menuLayout.maxHeight) !== null && _b !== void 0 ? _b : "70vh",
                    overflowY: "auto",
                    padding: 4,
                    position: menuLayout ? "fixed" : "absolute",
                    top: (_c = menuLayout === null || menuLayout === void 0 ? void 0 : menuLayout.top) !== null && _c !== void 0 ? _c : 0,
                    visibility: menuLayout ? "visible" : "hidden",
                    zIndex: 10,
                    ...menuStyle,
                    ...((menuLayout === null || menuLayout === void 0 ? void 0 : menuLayout.bottom) !== undefined ? { bottom: menuLayout.bottom } : {}),
                }, children: children }))] }));
}
exports.Dropdown = Dropdown;
